import angular from 'angular';
import currencyInputDropdown from './currencyInputDropdown';

export default angular
  .module('components.currencyInputDropdown', [])
  .component('currencyInputDropdown', currencyInputDropdown).name;
